import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/Home'
import store from '../store/main'
import access from "@/mixin/functions/access";

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next();
        return
    }

    next(window.i18nHelper.getUrl(''))
}

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        if (store.getters.getUserCompanyIsActive === false) {
            next(window.i18nHelper.getUrl('plans/compare'))
            return
        }

        if (store.getters.getUserRoles.length === 0 || to.meta.hasAccess()) {
            next()
        } else {
            console.log('router: access denied for ' + to.name)
            window.i18nHelper.flash('error.access', 'error')
        }

        return
    }

    next(window.i18nHelper.getUrl('login'))
}


const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'login',
            redirect: '/' + store.getters.getCurrentLang
        },
        {
            name: 'home',
            meta: {category: 'home', hasAccess: () => true},
            path: '/:lang',
            component: Home
        },
        {
            path: '/:lang/promo',
            name: 'login',
            component: () => import('../pages/PromoNew'),
            meta: {layout: 'EmptyLayout'},
        },
        {
            path: '/:lang/login',
            name: 'login',
            component: () => import('../pages/Login'),
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/:lang/forgot-password',
            name: 'forgot',
            component: () => import('../pages/ForgotPassword'),
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/:lang/reset-password/:token',
            name: 'reset',
            component: () => import('../pages/ResetPassword'),
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/:lang/logout',
            name: 'logout',
            component: () => import('../pages/User/Logout'),
        },

        // auto order
        {
            name: 'auto-order',
            meta: {category: 'products', hasAccess: () => access.canAutoOrder},
            path: '/:lang/orders',
            component: () => import('../pages/AutoOrder/AutoOrder'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'auto-order/list',
            meta: {category: 'products', hasAccess: () => access.canAutoOrder},
            path: '/:lang/orders/:id',
            component: () => import('../pages/AutoOrder/AutoOrderItem'),
            beforeEnter: ifAuthenticated,
        },

        //currency rate
        {
            name: 'currency-rate',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees()},
            path: '/:lang/currency-rate/list',
            component: () => import('../pages/CurrencyRate/List'),
        },

        // customers
        {
            name: 'customers/add',
            meta: {category: 'customers', hasAccess: () => access.canManageCustomers() || access.canSeeCustomerDebts()},
            path: '/:lang/customers/add',
            component: () => import('../pages/Customer/NewAdd'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'customers/addOld',
            meta: {category: 'customers', hasAccess: () => access.canManageCustomers() || access.canSeeCustomerDebts()},
            path: '/:lang/customers/addOld',
            component: () => import('../pages/Customer/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'customers',
            meta: {category: 'customers', hasAccess: () => access.canManageCustomers() || access.canSeeCustomerDebts()},
            path: '/:lang/customers',
            component: () => import('../pages/Customer/NewList'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'customers/debtors',
            meta: {category: 'customers', hasAccess: () => access.canManageCustomers() || access.canSeeCustomerDebts()},
            path: '/:lang/customers/debtors',
            component: () => import('../pages/Customer/DebtorList.vue'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'customersOld',
            meta: {category: 'customers', hasAccess: () => access.canManageCustomers() || access.canSeeCustomerDebts()},
            path: '/:lang/customersOld',
            component: () => import('../pages/Customer/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'customers/view',
            meta: {category: 'customers', hasAccess: () => access.canManageCustomers() || access.canSeeCustomerDebts()},
            path: '/:lang/customers/view',
            component: () => import('../pages/Customer/View.vue'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'customers/view',
            meta: {category: 'customers', hasAccess: () => access.canManageCustomers() || access.canSeeCustomerDebts()},
            path: '/:lang/customers/view/:id',
            component: () => import('../pages/Customer/View.vue'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'customer/view',
            meta: {category: 'customers', hasAccess: () => access.canManageCustomers() || access.canSeeCustomerDebts()},
            path: '/:lang/customer/view/:id/page/:page',
            component: () => import('../pages/Customer/View.vue'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'customer',
            meta: {category: 'customers', hasAccess: () => access.canManageCustomers() || access.canSeeCustomerDebts()},
            path: '/:lang/customer/page/:page',
            component: () => import('../pages/Customer/NewList'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'customers/edit',
            meta: {category: 'customers', hasAccess: () => access.canManageCustomers() || access.canSeeCustomerDebts()},
            path: '/:lang/customers/:id',
            component: () => import('../pages/Customer/NewAdd'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'customersId',
            meta: {category: 'customers', hasAccess: () => access.canManageCustomers() || access.canSeeCustomerDebts()},
            path: '/:lang/customersId/:id/page/:page',
            component: () => import('../pages/Customer/NewAdd'),
            beforeEnter: ifAuthenticated,
        },
        // supplier
        {
            name: 'suppliers',
            meta: {
                category: 'suppliers',
                hasAccess: () => access.canManagerSuppliers() || access.canSeeSupplierDebts()
            },
            path: '/:lang/suppliers',
            component: () => import('../pages/Supplier/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'supplier',
            meta: {
                category: 'suppliers',
                hasAccess: () => access.canManagerSuppliers() || access.canSeeSupplierDebts()
            },
            path: '/:lang/supplier/page/:page',
            component: () => import('../pages/Supplier/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'suppliersId',
            meta: {
                category: 'suppliers',
                hasAccess: () => access.canManagerSuppliers() || access.canSeeSupplierDebts()
            },
            path: '/:lang/suppliersId/:id/page/:page',
            component: () => import('../pages/Supplier/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'suppliers/add',
            meta: {
                category: 'suppliers',
                hasAccess: () => access.canManagerSuppliers() || access.canSeeSupplierDebts()
            },
            path: '/:lang/suppliers/add',
            component: () => import('../pages/Supplier/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'suppliers/edit',
            meta: {
                category: 'suppliers',
                hasAccess: () => access.canManagerSuppliers() || access.canSeeSupplierDebts()
            },
            path: '/:lang/suppliers/:id',
            component: () => import('../pages/Supplier/Add'),
            beforeEnter: ifAuthenticated,
        },

        // employees
        {
            name: 'employees/positions',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees()},
            path: '/:lang/employees/positions',
            component: () => import('../pages/Employee/Position/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'employees/positions/page',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees()},
            path: '/:lang/employees/positions/page/:page',
            component: () => import('../pages/Employee/Position/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'employees/positions/add',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees()},
            path: '/:lang/employees/positions/add',
            component: () => import('../pages/Employee/Position/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'employees/positions/show',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees()},
            path: '/:lang/employees/positions/:id',
            component: () => import('../pages/Employee/Position/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'employees/add',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees()},
            path: '/:lang/employees/add',
            component: () => import('../pages/Employee/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'employees/edit',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees()},
            path: '/:lang/employees/:id',
            component: () => import('../pages/Employee/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'employees/page',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees()},
            path: '/:lang/employees/page/:page',
            component: () => import('../pages/Employee/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'employees',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees()},
            path: '/:lang/employees',
            component: () => import('../pages/Employee/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'employees_at_work/page',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees()},
            path: '/:lang/employees-at-work/page/:page',
            component: () => import('../pages/Employee/AtWorkList'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'employees_at_work',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees()},
            path: '/:lang/employees-at-work',
            component: () => import('../pages/Employee/AtWorkList'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'employee',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees()},
            path: '/:lang/employee/:id',
            component: () => import('../pages/Employee/Profile'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'employee/bonus',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees()},
            path: '/:lang/employee-bonus/:id',
            component: () => import('../pages/Employee/EmployeeBonusList'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'employees_salary',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees()},
            path: '/:lang/employees-salary',
            component: () => import('../pages/Employee/Salary/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'employees/kpi/add',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees() || access.canManageKpis()},
            path: '/:lang/employees/kpi/add',
            component: () => import('../pages/Employee/KPI/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'employees/kpi/list',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees() || access.canManageKpis()},
            path: '/:lang/employees/kpi/list',
            component: () => import('../pages/Employee/KPI/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'employees/kpi/list/page',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees() || access.canManageKpis()},
            path: '/:lang/employees/kpi/list/page/:page',
            component: () => import('../pages/Employee/KPI/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'employees/kpi/employees/page',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees() || access.canManageKpis()},
            path: '/:lang/employees/kpi/employees/page/:page',
            component: () => import('../pages/Employee/KPI/ViewPage.vue'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'employees/kpi/employees',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees() || access.canManageKpis()},
            path: '/:lang/employees/kpi/employees',
            component: () => import('../pages/Employee/KPI/ViewPage.vue'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'employees/kpi/edit',
            meta: {category: 'company', hasAccess: () => access.canManageEmployees() || access.canManageKpis()},
            path: '/:lang/employees/kpi/:id',
            component: () => import('../pages/Employee/KPI/Add'),
            beforeEnter: ifAuthenticated,
        },

        // products
        {
            name: 'products/page',
            meta: {category: 'products', hasAccess: () => true},
            path: '/:lang/products/page/:page',
            component: () => import('../pages/Product/List'),
            beforeEnter: ifAuthenticated,
        },
        // {
        //     name: 'products/add',
        //     meta: {category: 'products', hasAccess: () => access.canManageProducts()},
        //     path: '/:lang/products/add',
        //     component: () => import('../pages/Product/Add'),
        //     beforeEnter: ifAuthenticated,
        // },
        // {
        //     name: 'products/addMany',
        //     meta: {category: 'products', hasAccess: () => access.canManageProducts()},
        //     path: '/:lang/products/add-many',
        //     component: () => import('../pages/Product/AddMany'),
        //     beforeEnter: ifAuthenticated,
        // },
        // {
        //     name: 'products/purchase',
        //     meta: {category: 'products', hasAccess: () => access.canPurchaseProducts()},
        //     path: '/:lang/products/:id/purchase',
        //     component: () => import('../pages/ProductPurchase/Purchase'),
        //     beforeEnter: ifAuthenticated,
        // },
        {
            name: 'products/purchase',
            meta: {category: 'products', hasAccess: () => access.canPurchaseProducts()},
            path: '/:lang/products/:id/purchase',
            component: () => import('../pages/ProductPurchase/PurchaseProduct'),
            beforeEnter: ifAuthenticated,
        },
        // {
        //     name: 'products/purchaseFew',
        //     meta: {category: 'products', hasAccess: () => access.canPurchaseProducts()},
        //     path: '/:lang/products/:id/purchase-few',
        //     component: () => import('../pages/ProductPurchase/PurchaseFew'),
        //     beforeEnter: ifAuthenticated,
        // },
        {
            name: 'products/purchase/warehouse',
            meta: {category: 'products', hasAccess: () => access.canPurchaseProducts()},
            path: '/:lang/products/:id/purchase/warehouse/:warehouseId/product/:productName',
            component: () => import('../pages/ProductPurchase/Purchase'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'products/transactions/page',
            meta: {category: 'products', hasAccess: () => access.canSeeProductPurchasesHistory()},
            path: '/:lang/products/transactions/page/:page',
            component: () => import('../pages/ProductPurchase/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'products/transaction/id',
            meta: {category: 'products', hasAccess: () => access.canSeeProductPurchasesHistory()},
            path: '/:lang/products/transactions/:id',
            component: () => import('../pages/ProductPurchase/Show'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'products/deleted',
            meta: {category: 'products', hasAccess: () => access.canManageProducts()},
            path: '/:lang/products/deleted',
            component: () => import('../pages/Product/ListDelete'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'products/deleted/page',
            meta: {category: 'products', hasAccess: () => access.canManageProducts()},
            path: '/:lang/products/deleted/page/:page',
            component: () => import('../pages/Product/ListDelete'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'products/transactions',
            meta: {category: 'products', hasAccess: () => access.canSeeProductPurchasesHistory()},
            path: '/:lang/products/transactions',
            component: () => import('../pages/ProductPurchase/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'products/view',
            meta: {category: 'products', hasAccess: () => true},
            path: '/:lang/products/:id',
            component: () => import('../pages/Product/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'products/history',
            meta: {category: 'products', hasAccess: () => true},
            path: '/:lang/products/:id/page/:page',
            component: () => import('../pages/Product/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'products',
            meta: {category: 'products', hasAccess: () => true},
            path: '/:lang/products',
            component: () => import('../pages/Product/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'product/modified-products',
            meta: {category: 'products', hasAccess: () => true},
            path: '/:lang/product-modify',
            component: () => import('../pages/Product/PriceModify/ProductModifyList'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'product/modify/page',
            meta: {category: 'products', hasAccess: () => true},
            path: '/:lang/product-modify/page/:page',
            component: () => import('../pages/Product/PriceModify/ProductModifyList'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'product/make-modify',
            meta: {category: 'products', hasAccess: () => true},
            path: '/:lang/product-modify-make',
            component: () => import('../pages/Product/PriceModify/ProductModify'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'product/modify',
            meta: {category: 'products', hasAccess: () => true},
            path: '/:lang/product-modify/:id',
            component: () => import('../pages/Product/PriceModify/ProductModifyListItem'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'import-excel',
            meta: {category: 'products', hasAccess: () => access.canPurchaseProducts()},
            path: '/:lang/import-excel',
            component: () => import('../pages/Product/ImportExcel'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'export-barcode',
            meta: {category: 'products', hasAccess: () => access.canPurchaseProducts()},
            path: '/:lang/export-barcode',
            component: () => import('../pages/Product/ExportBarcode'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'expiration-products',
            meta: {category: 'products', hasAccess: () => access.canPurchaseProducts()},
            path: '/:lang/expiration-products',
            component: () => import('../pages/ProductsInWarehouse/ExpirationProducts'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'excel-error',
            meta: {category: 'products', hasAccess: () => access.canPurchaseProducts()},
            path: '/:lang/excel-error',
            component: () => import('../pages/Product/ExcelError'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'imported-excel',
            meta: {category: 'products', hasAccess: () => access.canPurchaseProducts()},
            path: '/:lang/excel-was-imported',
            component: () => import('../pages/Product/ImportedExcel'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'scale',
            meta: {category: 'products', hasAccess: () => access.canPurchaseProducts()},
            path: '/:lang/scales',
            component: () => import('../pages/Product/Scale/List'),
            beforeEnter: ifAuthenticated,
        },

        // products-in-warehouses
        {
            name: 'products-in-warehouses',
            meta: {category: 'warehouses', hasAccess: () => true},
            path: '/:lang/products-in-warehouses',
            component: () => import('../pages/ProductsInWarehouse/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'products-in-warehouse',
            meta: {category: 'warehouses', hasAccess: () => true},
            path: '/:lang/products-in-warehouses/id/:id',
            component: () => import('../pages/ProductsInWarehouse/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'write-off',
            meta: {category: 'warehouses', hasAccess: () => access.canWriteOffProductInWarehouse()},
            path: '/:lang/write-off',
            component: () => import('../pages/ProductsInWarehouse/WriteOff'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'expired-product-write-off',
            meta: {category: 'warehouses', hasAccess: () => access.canWriteOffProductInWarehouse()},
            path: '/:lang/expired-product-write-off',
            component: () => import('../pages/ProductsInWarehouse/WriteOff'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'products-in-warehouses-write-off',
            meta: {category: 'warehouses', hasAccess: () => access.canWriteOffProductInWarehouse()},
            path: '/:lang/products-in-warehouses-write-off',
            component: () => import('../pages/ProductsInWarehouse/WriteOffList'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'products-in-warehouse-write-off',
            meta: {category: 'warehouses', hasAccess: () => access.canWriteOffProductInWarehouse()},
            path: '/:lang/products-in-warehouse-write-off/page/:page',
            component: () => import('../pages/ProductsInWarehouse/WriteOffList'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'products-in-warehouses/page',
            meta: {category: 'warehouses', hasAccess: () => true},
            path: '/:lang/products-in-warehouses/page/:page',
            component: () => import('../pages/ProductsInWarehouse/List'),
            beforeEnter: ifAuthenticated,
        },

        //Product-refund
        {
            name: 'purchaseRefund/List',
            meta: {category: 'return', hasAccess: () => access.canManageProducts()},
            path: '/:lang/purchase-refund',
            component: () => import('../pages/ProductRefund/PurchaseRefundList'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'purchaseRefund/List/page',
            meta: {category: 'return', hasAccess: () => access.canManageProducts()},
            path: '/:lang/purchase-refund/page/:page',
            component: () => import('../pages/ProductRefund/PurchaseRefundList'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'purchaseRefund',
            meta: {category: 'return', hasAccess: () => access.canManageProducts()},
            path: '/:lang/purchase-refund/:id',
            component: () => import('../pages/ProductRefund/PurchaseRefund'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'purchaseRefund/Add',
            meta: {category: 'return', hasAccess: () => access.canManageProducts()},
            path: '/:lang/add-purchase-refund',
            component: () => import('../pages/ProductRefund/Add'),
            beforeEnter: ifAuthenticated,
        },

        // warehouses
        {
            name: 'warehouses/add',
            meta: {category: 'warehouses', hasAccess: () => access.canStoreKeeping()},
            path: '/:lang/warehouses/add',
            component: () => import('../pages/Warehouse/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'warehouse/show',
            meta: {category: 'warehouses', hasAccess: () => access.canStoreKeeping()},
            path: '/:lang/warehouse/show/:id',
            component: () => import('../pages/Warehouse/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'warehouses/page',
            meta: {category: 'warehouses', hasAccess: () => true},
            path: '/:lang/warehouses/page/:page',
            component: () => import('../pages/Warehouse/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'warehouses',
            meta: {category: 'warehouses', hasAccess: () => true},
            path: '/:lang/warehouses',
            component: () => import('../pages/Warehouse/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'warehouse',
            meta: {category: 'warehouses', hasAccess: () => true},
            path: '/:lang/warehouses/:id/products',
            component: () => import('../pages/Warehouse/Show'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'change-warehouses',
            meta: {category: 'warehouses', hasAccess: () => true},
            path: '/:lang/change-warehouses',
            component: () => import('../pages/ProductsInWarehouse/ChangeWarehouse'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'inventories',
            meta: {category: 'warehouses', hasAccess: () => access.canMakeInventory()},
            path: '/:lang/inventory',
            component: () => import('../pages/Warehouse/Inventory/InventoryList'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'inventory/page',
            meta: {category: 'warehouses', hasAccess: () => access.canMakeInventory()},
            path: '/:lang/inventory/page/:page',
            component: () => import('../pages/Warehouse/Inventory/InventoryList'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'inventory',
            meta: {category: 'warehouses', hasAccess: () => access.canMakeInventory()},
            path: '/:lang/inventory/:id',
            component: () => import('../pages/Warehouse/Inventory/InventoryListItem'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'inventory-make',
            meta: {category: 'warehouses', hasAccess: () => access.canMakeInventory()},
            path: '/:lang/inventory-make',
            component: () => import('../pages/Warehouse/Inventory/InventoryMake'),
            beforeEnter: ifAuthenticated,
        },

        // product-categories
        {
            name: 'product-categories/add',
            meta: {category: 'products', hasAccess: () => access.canManageProducts()},
            path: '/:lang/product-categories/add',
            component: () => import('../pages/ProductCategory/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'product-categories/view',
            meta: {category: 'products', hasAccess: () => access.canManageProducts()},
            path: '/:lang/product-categories/:id',
            component: () => import('../pages/ProductCategory/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'product-categories/page',
            meta: {category: 'products', hasAccess: () => true},
            path: '/:lang/product-categories/page/:page',
            component: () => import('../pages/ProductCategory/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'product-categories',
            meta: {category: 'products', hasAccess: () => true},
            path: '/:lang/product-categories',
            component: () => import('../pages/ProductCategory/List'),
            beforeEnter: ifAuthenticated,
        },

        // sales
        // {
        //     name: 'sales/transaction',
        //     meta: {category: 'sales', hasAccess: () => access.canSeeSaleHistory() || access.canDeleteSaleHistory()},
        //     path: '/:lang/sales/transactions/:id',
        //     component: () => import('../pages/Sale/Show'),
        //     beforeEnter: ifAuthenticated,
        // },
        {
            name: 'sales/transaction/print',
            path: '/:lang/sales/transactions/:id/print',
            component: () => import('../pages/Sale/ShowPrintVersion'),
            meta: {layout: 'EmptyLayout', hasAccess: () => access.canSeeSaleHistory() || access.canDeleteSaleHistory()},
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'sales/transaction/check',
            path: '/:lang/sales/transactions/:id/check-print',
            component: () => import('../pages/Sale/ShowPrintCheckVersion'),
            meta: {layout: 'EmptyLayout', hasAccess: () => access.canSeeSaleHistory() || access.canDeleteSaleHistory()},
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'sales/transaction/check',
            path: '/:lang/sales/transactions/:key/local/check-print',
            component: () => import('../pages/Sale/LocalPrintCheckVersion'),
            meta: {layout: 'EmptyLayout', hasAccess: () => access.canSeeSaleHistory() || access.canDeleteSaleHistory()},
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'sales/transactions',
            meta: {category: 'sales', hasAccess: () => access.canSeeSaleHistory() || access.canDeleteSaleHistory()},
            path: '/:lang/sales/transactions',
            component: () => import('../pages/Sale/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'sales/draftSales',
            meta: {category: 'sales', hasAccess: () => access.canSeeSaleHistory() || access.canDeleteSaleHistory()},
            path: '/:lang/sales/drafts',
            component: () => import('../pages/Sale/DraftSale'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'sales/draftSales/page',
            meta: {category: 'sales', hasAccess: () => access.canSeeSaleHistory() || access.canDeleteSaleHistory()},
            path: '/:lang/sales/drafts/page/:page',
            component: () => import('../pages/Sale/DraftSale'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'sales/transactions/page',
            meta: {category: 'sales', hasAccess: () => access.canSeeSaleHistory() || access.canDeleteSaleHistory()},
            path: '/:lang/sales/transactions/page/:page',
            component: () => import('../pages/Sale/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'sales/orders',
            meta: {category: 'sales', hasAccess: () => access.canSale() || access.canManageTaxes()},
            path: '/:lang/sales/orders',
            component: () => import('../pages/Sale/OrdersPage.vue'),
            beforeEnter: ifAuthenticated,
        },
        // {
        //     name: 'sales/add',
        //     meta: {category: 'sales', hasAccess: () => access.canSale() || access.canDeleteSaleHistory()},
        //     path: '/:lang/sales/add',
        //     component: () => import('../pages/Sale/Add'),
        //     beforeEnter: ifAuthenticated,
        // },
        {
            name: 'sales/newSale',
            meta: {category: 'sales', hasAccess: () => access.canSale() || access.canDeleteSaleHistory()},
            path: '/:lang/sales/sale',
            component: () => import('../pages/Sale/LocalSale.vue'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'sales/afterSale',
            meta: {category: 'sales', hasAccess: () => access.canSeeSaleHistory() || access.canDeleteSaleHistory()},
            path: '/:lang/sales/after-sales/:id',
            component: () => import('../pages/Sale/AfterSale'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'sales/edit',
            meta: {category: 'sales', hasAccess: () => access.canSale() || access.canDeleteSaleHistory()},
            path: '/:lang/sales/edit/:id',
            component: () => import('../pages/Sale/NewSale'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'saleRefund/List',
            meta: {category: 'return', hasAccess: () => access.canSeeSaleHistory() || access.canDeleteSaleHistory()},
            path: '/:lang/saleRefund',
            component: () => import('../pages/SaleRefund/SaleRefundList'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'saleRefund/List/page',
            meta: {category: 'return', hasAccess: () => access.canSeeSaleHistory() || access.canDeleteSaleHistory()},
            path: '/:lang/saleRefund/page/:page',
            component: () => import('../pages/SaleRefund/SaleRefundList'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'saleRefund',
            meta: {category: 'return', hasAccess: () => access.canSeeSaleHistory() || access.canDeleteSaleHistory()},
            path: '/:lang/saleRefund/:id',
            component: () => import('../pages/SaleRefund/SaleRefund'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'saleRefund/Add',
            meta: {category: 'return', hasAccess: () => access.canSale() || access.canDeleteSaleHistory()},
            path: '/:lang/addSaleRefund',
            component: () => import('../pages/SaleRefund/Add'),
            beforeEnter: ifAuthenticated,
        },
        // Sales -> soon...
        {
            name: 'sales/taxes',
            meta: {category: 'sales', hasAccess: () => access.canSale() || access.canManageTaxes()},
            path: '/:lang/sales/taxes',
            component: () => import('../pages/Sale/Tax/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'sales/taxes/add',
            meta: {category: 'sales', hasAccess: () => access.canSale() || access.canManageTaxes()},
            path: '/:lang/sales/taxes/add',
            component: () => import('../pages/Sale/Tax/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'sales/taxes/edit',
            meta: {category: 'sales', hasAccess: () => access.canSale() || access.canManageTaxes()},
            path: '/:lang/sales/taxes/edit/:id',
            component: () => import('../pages/Sale/Tax/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'sales/discounts/add',
            meta: {category: 'sales', hasAccess: () => access.canSale() || access.canManageDiscounts()},
            path: '/:lang/sales/discounts/add',
            component: () => import('../pages/Sale/Discount/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'sales/discounts/edit',
            meta: {category: 'sales', hasAccess: () => access.canSale() || access.canManageDiscounts()},
            path: '/:lang/sales/discounts/edit/:id',
            component: () => import('../pages/Sale/Discount/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'sales/discounts',
            meta: {category: 'sales', hasAccess: () => access.canSale() || access.canManageDiscounts()},
            path: '/:lang/sales/discounts',
            component: () => import('../pages/Sale/Discount/Discount'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'sales/discounts/page',
            meta: {category: 'sales', hasAccess: () => access.canSale() || access.canManageDiscounts()},
            path: '/:lang/sales/discounts/page/:page',
            component: () => import('../pages/Sale/Discount/Discount'),
            beforeEnter: ifAuthenticated,
        },

        // Production
        {
            name: 'production/properties',
            path: '/:lang/production/properties',
            component: () => import('../pages/Production/properties/Properties.vue')
        },
        {
            name: 'production/finishedProducts',
            path: '/:lang/production/finishedProducts',
            component: () => import('../pages/Production/FinishedProduct/FinishedProduct.vue')
        },
        {
            name: 'production/finishedProducts/add',
            path: '/:lang/production/finishedProducts/add',
            component: () => import('../pages/Production/FinishedProduct/Add.vue')
        },
        {
            name: 'production/properties/add',
            path: '/:lang/production/properties/add',
            component: () => import('../pages/Production/properties/Add.vue')
        },

        // Services
        {
            name: 'services',
            meta: {category: 'services', hasAccess: () => access.canManageServices()},
            path: '/:lang/services',
            component: () => import('../pages/Services/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'services/page',
            meta: {category: 'services', hasAccess: () => access.canManageServices()},
            path: '/:lang/services/page/:page',
            component: () => import('../pages/Services/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'services/add',
            meta: {category: 'services', hasAccess: () => access.canManageServices()},
            path: '/:lang/services/add',
            component: () => import('../pages/Services/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'services/edit',
            meta: {category: 'services', hasAccess: () => access.canManageServices()},
            path: '/:lang/services/edit/:id',
            component: () => import('../pages/Services/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'services/transactions',
            meta: {category: 'services', hasAccess: () => access.canManageServices()},
            path: '/:lang/services/transactions',
            component: () => import('../pages/Services/ServiceTransaction'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'services/transactions/page',
            meta: {category: 'services', hasAccess: () => access.canManageServices()},
            path: '/:lang/services/transactions/page/:page',
            component: () => import('../pages/Services/ServiceTransaction'),
            beforeEnter: ifAuthenticated,
        },
        //statistics
        {
            name: 'statistics/show',
            meta: {
                category: 'statistics',
                hasAccess: () => access.canSeeStatisticsInfo() && access.hasAccessStatistics()
            },
            path: '/:lang/statistics/sale',
            component: () => import('../pages/Statistics/SaleShow'),
            beforeEnter: ifAuthenticated
        },
        {
            name: 'statistics/exDebtShow',
            meta: {
                category: 'statistics',
                hasAccess: () => access.canSeeStatisticsInfo() && access.hasAccessStatistics()
            },
            path: '/:lang/statistics/ex-debt',
            component: () => import('../pages/Statistics/ExDebtShow'),
            beforeEnter: ifAuthenticated
        },
        {
            name: 'statistics/debtShow',
            meta: {
                category: 'statistics',
                hasAccess: () => access.canSeeStatisticsInfo() && access.hasAccessStatistics()
            },
            path: '/:lang/statistics/debt',
            component: () => import('../pages/Statistics/DebtShow'),
            beforeEnter: ifAuthenticated
        },
        {
            name: 'statistics/employeeShow',
            meta: {
                category: 'statistics',
                hasAccess: () => access.canSeeStatisticsInfo() && access.hasAccessStatistics()
            },
            path: '/:lang/statistics/employee/:id',
            component: () => import('../pages/Statistics/EmployeeShow'),
            beforeEnter: ifAuthenticated
        },
        //statistics redesign
        {
            name: 'statistics/sale',
            meta: {
                category: 'statistics',
                hasAccess: () => access.canSeeStatisticsInfo() && access.hasAccessStatistics()
            },
            path: '/:lang/statistics/sales',
            component: () => import('../pages/Statistics/Sale/SaleStat.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            name: 'statistics/product',
            meta: {
                category: 'statistics',
                hasAccess: () => access.canSeeStatisticsInfo() && access.hasAccessStatistics()
            },
            path: '/:lang/statistics/product',
            component: () => import('../pages/Statistics/Product/ProductStat.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            name: 'statistics/product/page',
            meta: {
                category: 'statistics',
                hasAccess: () => access.canSeeStatisticsInfo() && access.hasAccessStatistics()
            },
            path: '/:lang/statistics/product/page/:page',
            component: () => import('../pages/Statistics/Product/ProductStat.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            name: 'statistics/product-dynamic',
            meta: {
                category: 'statistics',
                hasAccess: () => access.canSeeStatisticsInfo() && access.hasAccessStatistics()
            },
            path: '/:lang/statistics/product-dynamic',
            component: () => import('../pages/Statistics/ProductDynamic/List.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            name: 'statistics/service',
            meta: {
                category: 'statistics',
                hasAccess: () => access.canSeeStatisticsInfo() && access.hasAccessStatistics()
            },
            path: '/:lang/statistics/service',
            component: () => import('../pages/Statistics/Service/ServiceStat.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            name: 'statistics/service/page',
            meta: {
                category: 'statistics',
                hasAccess: () => access.canSeeStatisticsInfo() && access.hasAccessStatistics()
            },
            path: '/:lang/statistics/service/page/:page',
            component: () => import('../pages/Statistics/Service/ServiceStat.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            name: 'statistics/purchase',
            meta: {
                category: 'statistics',
                hasAccess: () => access.canSeeStatisticsInfo() && access.hasAccessStatistics()
            },
            path: '/:lang/statistics/purchase',
            component: () => import('../pages/Statistics/Purchase/PurchaseStat.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            name: 'statistics/employee',
            meta: {
                category: 'statistics',
                hasAccess: () => access.canSeeStatisticsInfo() && access.hasAccessStatistics()
            },
            path: '/:lang/statistics/employee',
            component: () => import('../pages/Statistics/Employee/EmployeeStat.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            name: 'statistics/customer',
            meta: {
                category: 'statistics',
                hasAccess: () => access.canSeeStatisticsInfo() && access.hasAccessStatistics()
            },
            path: '/:lang/statistics/customer',
            component: () => import('../pages/Statistics/Customer/CustomerStat.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            name: 'statistics/supplier',
            meta: {
                category: 'statistics',
                hasAccess: () => access.canSeeStatisticsInfo() && access.hasAccessStatistics()
            },
            path: '/:lang/statistics/supplier',
            component: () => import('../pages/Statistics/Supplier/SupplierStat.vue'),
            beforeEnter: ifAuthenticated
        },
        // company
        {
            name: 'company/add',
            meta: {category: 'company', hasAccess: () => true},
            path: '/:lang/company/add',
            component: () => import('../pages/Company/Add'),
            beforeEnter: ifNotAuthenticated,
        },
        {
            name: 'company/edit',
            meta: {category: 'company', hasAccess: () => true},
            path: '/:lang/company/edit',
            component: () => import('../pages/Company/Edit.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            name: 'company',
            meta: {category: 'company', hasAccess: () => access.canSeeCompanyInfo()},
            path: '/:lang/company',
            component: () => import('../pages/Company/Show'),
            beforeEnter: ifAuthenticated
        },
        {
            name: 'incomeAndOutcome',
            meta: {
                category: 'companyCount',
                hasAccess: () => (access.canManageCustomers() || access.canSeeCustomerDebts()) && access.hasAccessFinance()
            },
            path: '/:lang/incomeAndOutcome',
            component: () => import('../pages/IncomeAndOutCome/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'incomeAndOutcomes',
            path: '/:lang/incomeAndOutcomes/page/:page',
            meta: {
                category: 'companyCount',
                hasAccess: () => access.canManageCustomers() || access.canSeeCustomerDebts() && access.hasAccessFinance()
            },
            component: () => import('../pages/IncomeAndOutCome/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'incomeAndOutcome/add',
            meta: {
                category: 'companyCount',
                hasAccess: () => access.canManageCustomers() || access.canSeeCustomerDebts() && access.hasAccessFinance()
            },
            path: '/:lang/incomeAndOutcome/add',
            component: () => import('../pages/IncomeAndOutCome/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'incomeAndOutcome/edit',
            meta: {
                category: 'companyCount',
                hasAccess: () => access.canManageCustomers() || access.canSeeCustomerDebts() && access.hasAccessFinance()
            },
            path: '/:lang/incomeAndOutcome/:id',
            component: () => import('../pages/IncomeAndOutCome/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'report',
            meta: {
                category: 'companyCount',
                hasAccess: () => access.canSeeCompanyInfo() && access.hasAccessFinance()
            },
            path: '/:lang/report',
            component: () => import('../pages/IncomeAndOutCome/Report'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'incomeAndOutcomeCategory',
            meta: {
                category: 'companyCount',
                hasAccess: () => access.canSeeCompanyInfo() && access.hasAccessFinance()
            },
            path: '/:lang/incomeAndOutcomeCategory',
            component: () => import('../pages/IncomeAndOutcomeCategory/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'incomeAndOutcomeCategories',
            path: '/:lang/incomeAndOutcomeCategories/page/:page',
            meta: {
                category: 'companyCount',
                hasAccess: () => access.canSeeCompanyInfo() && access.hasAccessFinance()
            },
            component: () => import('../pages/IncomeAndOutcomeCategory/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'incomeAndOutcomeCategory/add',
            meta: {
                category: 'companyCount',
                hasAccess: () => access.canSeeCompanyInfo() && access.hasAccessFinance()
            },
            path: '/:lang/incomeAndOutcomeCategory/add',
            component: () => import('../pages/IncomeAndOutcomeCategory/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'incomeAndOutcomeCategory/edit',
            meta: {
                category: 'companyCount',
                hasAccess: () => access.canSeeCompanyInfo() && access.hasAccessFinance()
            },
            path: '/:lang/incomeAndOutcomeCategory/:id',
            component: () => import('../pages/IncomeAndOutcomeCategory/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'companyCount',
            meta: {category: 'companyCount', hasAccess: () => access.canSeeCompanyInfo() && access.hasAccessFinance()},
            path: '/:lang/companyCount',
            component: () => import('../pages/CompanyCount/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'companyCounts',
            path: '/:lang/companyCounts/page/:page',
            meta: {category: 'companyCount', hasAccess: () => access.canSeeCompanyInfo() && access.hasAccessFinance()},
            component: () => import('../pages/CompanyCount/List'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'companyCount/add',
            meta: {category: 'companyCount', hasAccess: () => access.canSeeCompanyInfo() && access.hasAccessFinance()},
            path: '/:lang/companyCount/add',
            component: () => import('../pages/CompanyCount/Add'),
            beforeEnter: ifAuthenticated,
        },
        {
            name: 'companyCount/edit',
            meta: {category: 'companyCount', hasAccess: () => access.canSeeCompanyInfo() && access.hasAccessFinance()},
            path: '/:lang/companyCount/:id',
            component: () => import('../pages/CompanyCount/Add'),
            beforeEnter: ifAuthenticated,
        },

        // plan
        {
            name: 'plans/compare',
            meta: {category: 'plans', hasAccess: () => true},
            path: '/:lang/plans/compare',
            component: () => import('../pages/Plan/Compare'),
        },
    ]
})

router.beforeEach(function (to, from, next) {
    let lang = to.params.lang;

    if (window.i18n.locale !== lang && window.i18nHelper.isValid(lang)) {
        store.dispatch('changeLang', lang)
    }

    next()
})

export default router;
